interface Props {
  connected: boolean;
  lastError: string | null;
}

export function ConnectionChip({ connected, lastError }: Props) {
  const state = connected ? "ok" : lastError ? "err" : "pending";
  const label = connected
    ? "Connected"
    : lastError
      ? "Disconnected"
      : "Connecting…";

  return (
    <div
      className={`chip chip-${state}`}
      title={lastError ?? undefined}
      aria-label={`AWS IoT ${label}`}
    >
      <span className="chip-dot" aria-hidden="true" />
      <span className="chip-label">{label}</span>
    </div>
  );
}
